import { useState, useEffect, useRef } from 'react';
import toast from 'react-hot-toast';
import { replayQueue } from '../lib/offlineQueue.js';
import { supabase } from '../lib/supabase.js';

export const useOnlineStatus = () => {
  const [online, setOnline] = useState(navigator.onLine);

  // FIX 3: use ref instead of state for wasOffline so the effect never
  // needs to re-register listeners due to a changing dependency.
  // Re-registering on every wasOffline state change creates a gap during
  // which a rapid online event can be missed.
  const wasOfflineRef = useRef(false);

  useEffect(() => {
    const handleOnline = async () => {
      setOnline(true);
      if (wasOfflineRef.current) {
        wasOfflineRef.current = false;
        toast.success('Back online — syncing changes…');
        await replayQueue(supabase);
      }
    };

    const handleOffline = () => {
      setOnline(false);
      wasOfflineRef.current = true;
      toast('You\'re offline — changes will sync when reconnected', {
        icon: '📡',
        duration: 4000,
      });
    };

    window.addEventListener('online',  handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online',  handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []); // FIX 3: empty deps — listeners registered once, never torn down on state change

  return online;
};
